export interface SEOConfig {
  title: string;
  description: string;
  keywords?: string;
  ogImage?: string;
}

export const seoConfig: Record<string, SEOConfig> = {
  workouts: {
    title: 'Free Weightlifting Planner - Create Workouts, Templates & Track Progress | Gym Planner',
    description: 'Completely free weightlifting and workout planner. Create custom exercises, build workout templates, and track your progress. Perfect for strength training and fitness goals.',
    keywords: 'free workout planner, weightlifting planner, exercise creator, workout templates, progress tracking, strength training, fitness tracker, gym routine builder'
  },
  exercises: {
    title: 'Exercise Creator & Library - Build Custom Workouts | Free Weightlifting Planner',
    description: 'Create custom exercises and browse our comprehensive exercise database. Build personalized weightlifting routines and track your strength training progress. 100% free.',
    keywords: 'exercise creator, custom exercises, weightlifting exercises, strength training, exercise database, workout builder, free fitness app'
  },
  progress: {
    title: 'Progress Tracking - Free Weightlifting & Strength Analytics | Gym Planner',
    description: 'Track your weightlifting progress with detailed analytics and performance charts. Monitor strength gains, workout history, and fitness improvements. Free progress tracking.',
    keywords: 'progress tracking, weightlifting progress, strength analytics, workout history, fitness tracking, performance charts, free fitness app'
  },
  food: {
    title: 'Nutrition Tracker - Meal Planning & Calorie Counter | Gym Planner',
    description: 'Track nutrition, plan meals, count calories, and manage your diet with our comprehensive nutrition tracking tools. Perfect complement to your fitness routine.',
    keywords: 'nutrition tracker, meal planning, calorie counter, diet tracking, fitness nutrition'
  },
  feedback: {
    title: 'Contact & Feedback - Help Improve Our Free Weightlifting Planner',
    description: 'Send feedback, report issues, or contact the Gym Planner team. Help us build the best free workout planning and weightlifting tracking app.',
    keywords: 'contact, feedback, support, gym planner help, free workout app'
  },
  about: {
    title: 'About Gym Planner - Free Weightlifting Planner & Workout Tracker',
    description: 'Learn about Gym Planner: a simple and free app to create workouts, manage templates, track progress, and improve your fitness journey.',
    keywords: 'about gym planner, free workout planner, weightlifting tracker, fitness app'
  }
};
